import { useAuth0 } from '@auth0/auth0-react'
import { PageWrapper } from '~components/page-wrapper'
import { Box, Link } from '@mui/material'
import { Link as RouterLink } from 'react-router-dom'
import LoginButton from './components/login-button'
import LogoutButton from './components/logout-button'

export function TopNavigationOpenPages() {
  const { isAuthenticated } = useAuth0()
  return (
    <PageWrapper sx={{ py: '0 !important' }}>
      <Box
        component="nav"
        sx={{
          display: 'flex',
          flexDirection: { xs: 'column', md: 'row' },
          justifyContent: 'space-between',
          alignItems: 'center',
          pt: 3,
          pb: 3,
        }}
      >
        <Link component={RouterLink} to="">
          <img
            src="/maersk.svg"
            alt="Maersk Logo"
            style={{ width: '100%', height: 24 }}
          />
        </Link>
        <Box
          sx={{
            mt: { xs: 3, md: 0 },
            display: 'flex',
            justifyContent: 'end',
            alignItems: 'center',
          }}
        >
          {isAuthenticated ? <LogoutButton /> : <LoginButton />}
        </Box>
      </Box>
    </PageWrapper>
  )
}
